import * as React from "react";
import { postAsync } from "../utils/net";
import { Button } from "reactstrap";
import i18n from "../i18n";
import { Environment } from "../models/environment";
import { ModalNotification } from "../utils/modalNotification";

export interface NluReleaseProps {
    environments: Environment[]
}
export interface NluReleaseState {
    targetEnvironments: Environment[],
    currentTarget: Environment,
    sourceEnvironmentsNames: string[],
    currentSourceName: string,
    targetEnvironmentSelected: boolean,
    showModal: boolean;
    modalMessage: string;
    modalResolve?: () => void;
}

export class NluRelease extends React.Component<
    NluReleaseProps,
    NluReleaseState
    > {

    constructor(props: NluReleaseProps) {
        super(props);

        this.onEnvironmentTargetChange = this.onEnvironmentTargetChange.bind(this);
        this.onEnvironmentSourceChange = this.onEnvironmentSourceChange.bind(this);

        var targetEnvironments = this.props.environments.filter(t => this.getSourceEnvironmentsNames(t).length > 0);

        if (targetEnvironments.length > 0) {
            var currentTarget = targetEnvironments[0];

            var sourceEnvironmentsNames = this.getSourceEnvironmentsNames(currentTarget);

            this.state = {
                targetEnvironments: targetEnvironments,
                currentTarget: currentTarget,
                sourceEnvironmentsNames: sourceEnvironmentsNames,
                currentSourceName: sourceEnvironmentsNames[0],
                targetEnvironmentSelected: false,
                showModal: false,
                modalMessage: ""
            };

            this.showModal = this.showModal.bind(this);
            this.hideModal = this.hideModal.bind(this);
        }
    }

    private showModal(message: string): Promise<void> {
        return new Promise((resolve) => {
            this.setState({ showModal: true, modalMessage: message, modalResolve: resolve });
        });
    }

    private hideModal() {
        this.setState({ showModal: false, modalMessage: "" }, () => {
            if (this.state.modalResolve) {
                this.state.modalResolve();
                this.setState({ modalResolve: undefined });
            }
        });
    }

    render() {

        if (!this.state) {
            return (
                <form>
                    <h1>{i18n.Release.NLU.Title}</h1>
                    <br />
                    <div>{i18n.Release.NLU.NoModelAvailable}</div>
                </form>
            );
        }

        return (
            <form>
                <h1>{i18n.Release.NLU.Title}</h1>
                <br />
                <div>{i18n.Release.NLU.MainText}</div>
                <br />
                <div className="form-group">
                    <label>{i18n.Release.NLU.TargetLabel}</label>
                    <select
                        className="form-control"
                        onChange={this.onEnvironmentTargetChange}
                        value={this.state.targetEnvironmentSelected ? this.state.currentTarget.name : ""}
                    >
                        <option value="" disabled={true}>{i18n.Release.NLU.SelectEnvironment}</option>
                        {this.state.targetEnvironments.map(o =>
                            <option key={o.name} value={o.name}>{o.name}</option>)}
                    </select>
                </div>

                {(this.state.targetEnvironmentSelected) && (
                    <div className="form-group">
                        <label>{i18n.Release.NLU.SourceLabel}</label>
                        <select className="form-control" onChange={this.onEnvironmentSourceChange}>
                            {this.state.sourceEnvironmentsNames.map(source =>
                                <option key={source} value={source}>
                                    {i18n.Release.NLU.ImportFrom + " " + source}
                                </option>)}
                        </select>
                        <br />
                    </div>)}
                <div>
                    {(this.state.targetEnvironmentSelected) && (
                        <Button
                            color="primary"
                            onClick={() =>
                                this.releaseNluKb(this.state.currentSourceName, this.state.currentTarget.name)}
                        >
                            Release
                        </Button>
                    )
                    }
                </div>
                <ModalNotification
                    modalMessage={this.state.modalMessage}
                    showModal={this.state.showModal}
                    onClose={this.hideModal}
                />
            </form>
        );
    }

    private getSourceEnvironmentsNames(targetEnvironment: Environment) {

        var sourceEnvironmentsNames = this.props.environments.
            filter(s => s.nextEnvironment === targetEnvironment.name).map(s => s.name);

        return sourceEnvironmentsNames;

    }

    private onEnvironmentTargetChange(event: React.ChangeEvent<HTMLSelectElement>) {

        const target = this.state.targetEnvironments.find(e => e.name === event.target.value);

        if (target) {

            var sourceEnvironmentsNames = this.getSourceEnvironmentsNames(target);

            this.setState({
                currentTarget: target,
                sourceEnvironmentsNames: sourceEnvironmentsNames,
                currentSourceName: sourceEnvironmentsNames[0],
                targetEnvironmentSelected: true
            });
        }
    }

    private onEnvironmentSourceChange(event: React.ChangeEvent<HTMLSelectElement>) {

        this.setState({
            currentSourceName: event.target.value
        });
    }

    private async releaseNluKb(sourceEnvironmentName: string, targetEnvironmentName: string) {
        const message = "Do you want to publish " + sourceEnvironmentName + " model on " + targetEnvironmentName + "?"
        if (!confirm(message)) {
            return;
        }

        const body = {
            source: sourceEnvironmentName,
            target: targetEnvironmentName
        };
        const result = await postAsync("/api/ReleaseManagement/nlu/release", body);
        if (result.ok) {
            await this.showModal(i18n.Release.NLU.PublishJobStarted);
        }
    }
}


// WEBPACK FOOTER //
// ./src/release-management/nlu-release.tsx